import { ColoredChip } from '../ColoredChip';

export const BetaBadge = () => {
  return (
    <ColoredChip variant="rounded" color="green" mode="light" size="small">
      Beta
    </ColoredChip>
  );
};
